module.exports = __webpack_public_path__ + "static/media/catcriada.40d52555.png";